import { addToGlobalThisRet } from "@plugins";

class SimplePopup {
    constructor(el, options) {
        if (!el) return;
        this.el = el;
        this.o = options;
        this.closeBtn = this.el.querySelector(".js-simple-popup-close");
        this.init();
    }

    close() {
        this.el.classList.remove("active");
    }

    open() {
        this.el.classList.add("active");
    }

    init() {
        this.closeBtn.addEventListener("click", () => {
            this.close();
        });

        ["click", "touchstart"].forEach((eventType) => {
            document.addEventListener(eventType, (evt) => {
                if (!this.el.contains(evt.target)) {
                    this.close();
                }
            });
        });
    }
}

let popup = document.querySelector(".js-simple-popup");
popup = new SimplePopup(popup);

addToGlobalThisRet(popup, "simplePopup");
